import { Component, OnDestroy, Input } from '@angular/core';
import { MatTableDataSource, MatSnackBar } from '@angular/material';
import { Subscription } from 'rxjs';
import { EntidadResponsable } from '../entidad-responsable/entidad-responsable';
import { Usuario } from '../../../../interfaces/usuario';
import { PermisoService } from '../../../../providers/permiso.service';
import { EntidadResponsableService } from '../entidad-responsable/entidad-responsable.service';

@Component({
  selector: 'app-listar-entidad-responsables',
  templateUrl: './listar-entidad-responsables.component.html',
  styleUrls: ['./listar-entidad-responsables.component.scss']
})
export class ListarEntidadResponsablesComponent implements OnDestroy {
  actualizarTablaTimeout: any; // prevenir muchos llamados consecutivos al webserver
  flag_primera_carga: boolean = true; // primera solicitud a traer datos
  cargandoTimeout: any;
  cargando: boolean = true; // para mostrar el progress-bar luego de un tiempo de busqueda
  tablaEntidadResponsablesColumnas = ['usuario', 'nombre', 'apellido'];
  entidadResponsablesDataSource = new MatTableDataSource();
  getEntidadResponsablesSuscripcion = new Subscription();
  entidadResponsablesCount: number = 0;
  IdEntidad: number | string = '';

  private _acciones: boolean = false;

  @Input() public set acciones(acciones: boolean) {
    if (acciones) {
      // acciones si
      this.permisoService.tienePermiso('TAREA-RESPONSABLE-ACCIONES').then(tienePermiso => {
        if (tienePermiso) {
          this.tablaEntidadResponsablesColumnas.push('acciones');
        }
      });
    } else {
      // acciones no
      this.tablaEntidadResponsablesColumnas.forEach((columna: string, index: number) => {
        if (columna == 'acciones') {
          this.tablaEntidadResponsablesColumnas.splice(index, 1);
          return;
        }
      });
    }

    this._acciones = acciones;
  }

  public get acciones(): boolean {
    return this._acciones;
  };

  constructor(
    private EntidadResponsableService: EntidadResponsableService,
    private permisoService: PermisoService,
    private snackBar: MatSnackBar
  ) { }

  actualizarTabla(): void {
    clearTimeout(this.actualizarTablaTimeout);
    this.actualizarTablaTimeout = setTimeout(() => {
      clearTimeout(this.cargandoTimeout);
      this.cargandoTimeout = setTimeout(() => { // mostrar cargando si tarda mas de algun tiempo de busqueda
        this.cargando = true;
      }, 750);

      if (this.getEntidadResponsablesSuscripcion && !this.getEntidadResponsablesSuscripcion.closed) {
        this.getEntidadResponsablesSuscripcion.unsubscribe();
      }

      this.getEntidadResponsablesSuscripcion = this.EntidadResponsableService
        .getEntidadResponsables(
          {
            page: null,
            pageSize: null
          },
          {
            sort: null,
            order: null
          },
          {
            IdEntidad: this.IdEntidad
          }
        )
        .subscribe( // suscribimos una nueva busqueda
          respuesta => {
            if (respuesta.estado == 1 && respuesta.data) {
              if (respuesta.data.total) {
                this.entidadResponsablesCount = respuesta.data.total;
              }

              var entidadResponsables: EntidadResponsable[] = []; // array de datos obtenidos
              if (respuesta.data.responsables) {
                respuesta.data.responsables.forEach(entidadResponsable => {
                  entidadResponsables.push(new EntidadResponsable(
                    entidadResponsable.IdUsuResponsable,
                    new Usuario(
                      entidadResponsable.usuario.IdUsuario,
                      entidadResponsable.usuario.usuario,
                      null,
                      null,
                      null,
                      entidadResponsable.usuario.nombre,
                      entidadResponsable.usuario.apellido,
                      null,
                      null,
                      null,
                      false,
                      false
                    )
                  ));
                });
              }

              this.entidadResponsablesDataSource.data = entidadResponsables;
            }
          },
          () => {
            clearTimeout(this.cargandoTimeout); // ya no es necesario mostrar la progress bar
            this.cargando = false; // ocultar progress bar si se estaba mostrando
          },
          () => {
            clearTimeout(this.cargandoTimeout); // ya no es necesario mostrar la progress bar
            this.cargando = false; // ocultar progress bar si se estaba mostrando
          }
        );
    }, (this.flag_primera_carga ? 0 : 220));

    this.flag_primera_carga = false;
  }

  ngOnDestroy() {
    if (this.getEntidadResponsablesSuscripcion && !this.getEntidadResponsablesSuscripcion.closed) {
      this.getEntidadResponsablesSuscripcion.unsubscribe();
    }
  }
}
